import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { BottomSheetContentLayout, Box, Button, Column, Row, Typography } from 'seagull';
import { buildSheetFields, sheetTotalText } from './ChargeEditSheet.utils';
export function ChargeEditSheet(param) {
    let { item, columnParams, mode, issueDate, header, submitLabel, submitTestId, totalLabel, totalTestId, onApply, onClose } = param;
    const draftForm = useForm({
        mode: 'all',
        defaultValues: {
            mode,
            issueDate,
            items: [
                item
            ]
        }
    });
    const draftItem = useWatch({
        control: draftForm.control,
        name: 'items.0',
        defaultValue: item
    });
    const sheetParams = useMemo(()=>_object_spread_props(_object_spread({}, columnParams), {
            control: draftForm.control,
            trigger: draftForm.trigger
        }), [
        columnParams,
        draftForm.control,
        draftForm.trigger
    ]);
    const fields = buildSheetFields(draftItem, 0, sheetParams);
    const apply = async ()=>{
        const isValid = await draftForm.trigger();
        if (!isValid) return;
        onApply(draftForm.getValues('items.0'));
        onClose();
    };
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentGutter: "m",
        header: _object_spread({
            gutter: 'm'
        }, header),
        footer: {
            paddingBottom: 16,
            content: /*#__PURE__*/ _jsxs(Column, {
                gap: 16,
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        justifyContent: "space-between",
                        alignItems: "center",
                        testId: totalTestId,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                weight: "bold",
                                children: totalLabel
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                weight: "bold",
                                children: sheetTotalText(draftItem)
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        bi: {
                            name: 'bill_item_edit_submit'
                        },
                        fullWidth: true,
                        testId: submitTestId,
                        onClick: apply,
                        children: submitLabel
                    })
                ]
            })
        },
        children: /*#__PURE__*/ _jsx(Column, {
            gap: 16,
            children: fields.map((field)=>/*#__PURE__*/ _jsxs(Column, {
                    gap: 4,
                    testId: sheetParams.testIds.EditFieldRow(0, field.key),
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            skin: "secondary",
                            variant: "paragraph2",
                            testId: sheetParams.testIds.EditFieldLabel(0, field.key),
                            children: field.label
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            children: field.node
                        })
                    ]
                }, field.key))
        })
    });
}
